import * as React from 'react'

import { DropdownInput, RadioButton } from '../../../Shared/index';
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility';

const MONTHLY = 'Monthly';
const WEEKLY = 'Weekly';
const ON = 'On';
const OFF = 'Off';

const ReportSubscriptionModal = ({ cancel, currentSubscription, isOpen, save }) => {
  const { modalRef } = useModalAccessibility(cancel, isOpen);

  const [isSubscribed, setIsSubscribed] = React.useState(Boolean(currentSubscription));
  const [frequency, setFrequency] = React.useState(currentSubscription?.frequency || MONTHLY);

  React.useEffect(() => {
    if (!isOpen) return;

    setIsSubscribed(Boolean(currentSubscription));
    setFrequency(currentSubscription?.frequency || MONTHLY);
  }, [currentSubscription, isOpen]);

  if (!isOpen) return null;

  const frequencyOptions = [{ "value": MONTHLY, "label": MONTHLY }, { "value": WEEKLY, "label": WEEKLY }]

  const handleFrequencyOptionChange = (e: { value: string }) => {
    setFrequency(e.value)
  }

  const handleIsSubscribedOptionChange = (option: { target: { value: string } }) => {
    setIsSubscribed(option.target.value === ON)
  }

  function handleSaveClick() { save(isSubscribed, frequency, currentSubscription) }

  function renderFrequencyOptions() {
    const selectedFrequency = frequencyOptions.find(option => frequency === option.value)

    return (
      <div className="frequency-options">
        <label className="frequency-label" htmlFor="frequency">
          <span>Frequency</span>
        </label>
        <DropdownInput
          ariaLabel="Frequency"
          className={`${isSubscribed ? '' : 'disabled'} focus-on-light`}
          disabled={!isSubscribed}
          handleChange={handleFrequencyOptionChange}
          id="frequency"
          isSearchable={false}
          label=""
          options={frequencyOptions}
          value={selectedFrequency}
        />
      </div>
    )
  }

  function renderIsSubscribedOptions() {
    return (
      <div className="is-subscribed-options">
        <h3 className="is-subscribed-label">Email me this report</h3>
        <RadioButton
          ariaLabel='is-subscribed-on-button'
          label={ON}
          onClick={handleIsSubscribedOptionChange}
          selected={isSubscribed}
          value={ON}
        />
        <RadioButton
          ariaLabel='is-subscribed-on-button'
          label={OFF}
          onClick={handleIsSubscribedOptionChange}
          selected={!isSubscribed}
          value={OFF}
        />
      </div >
    )
  }

  function renderIsSubscribedAndFrequency() {
    return (
      <div className="is-subscribed-and-frequency">
        {renderIsSubscribedOptions()}
        {renderFrequencyOptions()}
      </div>
    )
  }

  function renderSaveAndCancelButtons() {
    return (
      <div className="save-and-cancel-buttons">
        <button
          className="quill-button medium outlined grey focus-on-light"
          onClick={cancel}
          type="button"
        >
          Cancel
        </button>
        <button
          className="quill-button medium contained green focus-on-light"
          onClick={handleSaveClick}
          type="button"
        >
          Save
        </button>
      </div>
    )
  }

  function renderTitleAndDescription() {
    return (
      <div className="title-and-description">
        <h2 id="manageReportSubscriptionModalTitle">Subscribe to this report</h2>
        <p className="description">
          Keep up to date by having this report delivered to your inbox on a recurring basis. It will use filters
          currently applied when you subscribe, so please review them before doing so.  You can always change your
          filters later by turning off the report and re-subscribing.
        </p>
      </div>
    )
  }

  return (
    <div className="modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="manageReportSubscriptionModalTitle"
        aria-modal="true"
        className="manage-report-subscription-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          {renderTitleAndDescription()}
          {renderIsSubscribedAndFrequency()}
          {renderSaveAndCancelButtons()}
        </div>
      </div>
    </div>
  );
}

export default ReportSubscriptionModal;
